import { ELEMENT_RETRY_COUNT, findElement } from '../domLocator'
import humanLabel from '../humanLabel'
import { ClientTool, failure, success } from '../Tool'

interface Input extends Record<string, unknown> {
  agentId: string
  value: string
}

/**
 * Fills a text input identified by data-agent-id using React's native setter so
 * controlled component state updates correctly. If the located element is a
 * container (not an input), searches for the first input within — handles
 * components that wrap the native input in a div.
 */
const domFill: ClientTool = {
  name: 'dom_fill',
  category: 'mutation',
  execute: async (rawInput) => {
    const { agentId, value } = rawInput as Input
    const el = await findElement(agentId)
    if (!el) {
      return failure(`Element ${agentId} not found after ${ELEMENT_RETRY_COUNT} retries`)
    }
    const input = (
      el instanceof HTMLInputElement ? el : el.querySelector('input')
    ) as HTMLInputElement | null
    if (!input) {
      return failure(`No input found within ${agentId}`)
    }
    const nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set
    if (nativeSetter) {
      nativeSetter.call(input, value)
    } else {
      input.value = value
    }
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))
    return success()
  },
  getStepLabel: (rawInput) => {
    const { agentId } = rawInput as Input
    return `Entering ${humanLabel(agentId)}…`
  }
}

export default domFill
